import ContextProvider from './ContextProvider';

export default ContextProvider;
